import { matchesTokens } from '@medcom/shared-ui/utils/tokenSearch.ts';
import type { CumulativeGroup, LabResultObservationResult } from '../generated/openapi/befunde-api';
import type { ValuesFilter } from '../store/useLabResultViewStore.ts';

function matchFilter(result: LabResultObservationResult, valuesFilter: ValuesFilter, tokens: string[]) {
  const pathological = (result.pathological || '').length > 0;
  if ((valuesFilter === 'PATHOLOGICAL' && !pathological) || (valuesFilter === 'NONE_PATHOLOGICAL' && pathological)) {
    return false;
  }
  return matchesTokens(result, tokens, [r => r.testName]);
}

export type Group = {
  groupName: string;
  results: LabResultObservationResult[];
};

/**
 * Intentionally no hash grouping used so that the order of the results is preserved,
 * regardless of whether a group can occur more than once
 */
export const filterLabResultObservationResultGroups = (
  results: LabResultObservationResult[],
  valuesFilter: ValuesFilter,
  tokens: string[]
): Group[] => {
  const groups = [];

  let lastGroup: Group | null = null;
  for (const result of results) {
    if (matchFilter(result, valuesFilter, tokens)) {
      // biome-ignore lint/style/noNonNullAssertion: is no issue
      if (lastGroup === null || lastGroup!.groupName !== result.resultGroup) {
        lastGroup = { groupName: result.resultGroup || '', results: [result] };
        groups.push(lastGroup);
      } else {
        lastGroup.results.push(result);
      }
    }
  }

  return groups;
};

export const filterCumulativeGroups = (
  results: CumulativeGroup[] | null | undefined,
  valuesFilter: ValuesFilter,
  tokens: string[]
): CumulativeGroup[] => {
  return (results || [])
    .map(group => {
      return {
        ...group,
        parameters: group.parameters.filter(p => p.results.some(v => v && matchFilter(v, valuesFilter, tokens))),
      };
    })
    .filter(r => r.parameters.length > 0);
};
